import { IRoles } from "../types/roles";



export const roles :IRoles = {
    Admin : 'ADMIN',
    User : 'USER'
}